export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11875.6ee625a2.jpg";